// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"57b17be0","81":"9dbd3d08","437":"73514eb8"}[chunkId] + ".chunk.css";
};